var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8464 5.26679L5.58577 5.30508L0.943352 5.98719L0.942985 5.98725C0.525341 6.04829 0.345629 6.57718 0.658438 6.88413L0.658579 6.88427L4.01726 10.1827L4.20374 10.3659L4.15981 10.6235L3.36548 15.2826C3.36548 15.2827 3.36547 15.2827 3.36547 15.2827C3.29106 15.7212 3.74601 16.0323 4.11129 15.8372L4.11287 15.8363L8.26594 13.6363L8.5 13.5123L8.73406 13.6363L12.8871 15.8363L12.8872 15.8364C13.256 16.0318 13.7084 15.7181 13.6345 15.2827C13.6345 15.2827 13.6345 15.2827 13.6345 15.2826L12.8402 10.6235L12.7963 10.3659L12.9827 10.1827L16.3414 6.88427L16.3416 6.88413C16.6544 6.57718 16.4747 6.04829 16.057 5.98725L16.0566 5.98719L11.4142 5.30508L11.1536 5.26679L11.0378 5.03018L8.96331 0.791133C8.96325 0.791005 8.96318 0.790878 8.96312 0.79075C8.7718 0.402561 8.22663 0.403793 8.03714 0.790214L5.8464 5.26679ZM5.8464 5.26679L5.96219 5.03018L8.03705 0.790402L5.8464 5.26679Z",
    fill: "#E5E5E5",
    stroke: "#CACACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.21b2f79c.svg";
export { ForwardRef as ReactComponent };